import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import Home from './pages/Home';
import GameRoom from './pages/GameRoom';
import AdminPanel from './pages/AdminPanel';
import MyGames from './pages/MyGames';
import Transactions from './pages/Transactions';
import DrawResults from './pages/DrawResults';
import Settings from './pages/Settings';
import HostInfo from './pages/HostInfo';
import AuctionRoom from './pages/AuctionRoom';
import PublicProfile from './pages/PublicProfile';
import Guide from './pages/Guide';
import Leaderboard from './pages/Leaderboard';
import Shop from './pages/Shop';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Axios interceptor for JWT
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function App() {
  useEffect(() => {
    // Initialize Telegram WebApp
    const tg = window.Telegram?.WebApp;
    if (tg) {
      tg.ready();
      tg.expand();
      tg.setHeaderColor('#0a0e27');
      tg.setBackgroundColor('#0a0e27');
    }
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/game/:gameId" element={<GameRoom />} />
            <Route path="/my-games" element={<MyGames />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/draws" element={<DrawResults />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/host-info" element={<HostInfo />} />
            <Route path="/auction/:auctionId" element={<AuctionRoom />} />
            <Route path="/profile/:username" element={<PublicProfile />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
